import './header.scss';
import Base from '../base/base';

interface HeaderOptions {
  debug?: boolean;
  [key: string]: any;
}

export default class Header extends Base {
  constructor(options: HeaderOptions = {}) {
    // Pass the debug option to the Base class constructor
    super(options.debug || false);
    this.init();
  }

  init(): void {
    this.log('Header initialized');
  }
}